import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import { ErrorMessages } from '@/core/components'
import CheckoutLayoutSkeleton from '@/core/checkout/components/checkout-layout-skeleton.component'
import { useOmanPayments } from './useOmanPayments'
import ShipToSection from './components/ship-to-section.component'
import ShippingMethodSection from './components/shipping-method-section.component'
import PaymentMethodsBox from './components/PaymentMethodsBox'
import PreSummaryBox from '../checkout/components/PreSummaryBox'
import CheckoutStepper from '../checkout/components/CheckoutStepper'
import { PageWrapper, PaymentLayoutGrid, SectionBox } from './payments.styles'

const OmanPaymentsModule = () => {
    const { isLoading, hasLoadError, loadErrors } = useOmanPayments()

    if (hasLoadError) {
        return (
            <PageWrapper data-testid="oman-payments-error-wrapper">
                <CheckoutStepper activeStep="purchase" data-testid="oman-payments-stepper" />
                <PaymentLayoutGrid data-testid="oman-payments-error-grid">
                    <Box sx={{ gridColumn: '1 / -1' }} data-testid="oman-payments-error-box">
                        <ErrorMessages list={loadErrors} showUuid data-testid="oman-payments-error-messages" />
                    </Box>
                </PaymentLayoutGrid>
            </PageWrapper>
        )
    }

    if (isLoading) {
        return (
            <PageWrapper data-testid="oman-payments-loading-wrapper">
                <CheckoutLayoutSkeleton activeIndex={2} data-testid="oman-payments-skeleton" />
            </PageWrapper>
        )
    }

    return (
        <PageWrapper data-testid="oman-payments-wrapper">
            <CheckoutStepper activeStep="purchase" data-testid="oman-payments-stepper" />
            <PaymentLayoutGrid data-testid="oman-payments-layout">
                <Stack spacing={2} sx={{ gridColumn: { lg: '1' } }} data-testid="oman-payments-left-column">
                    <SectionBox data-testid="oman-payments-section-box">
                        <ShipToSection data-testid="oman-payments-ship-to" />
                        <Divider sx={{ my: 2 }} data-testid="oman-payments-divider" />
                        <ShippingMethodSection data-testid="oman-payments-shipping-method" />
                    </SectionBox>
                    <PaymentMethodsBox data-testid="oman-payments-methods-box" />
                </Stack>
                <Box
                    sx={{
                        order: { xs: -1, lg: 0 },
                        gridColumn: { lg: '2' },
                        gridRow: { lg: '1' }
                    }}
                    data-testid="oman-payments-sidebar">
                    <PreSummaryBox readOnly data-testid="oman-payments-pre-summary" />
                </Box>
            </PaymentLayoutGrid>
        </PageWrapper>
    )
}

export default OmanPaymentsModule
